<template>
    <div class="main">
        <!-- <h1>OCTS Indicator Types</h1>
        <chart-card :items="OCTSFullData" title="OCTS Indicator Types">
        </chart-card> -->
        <!-- <bar-chart-card :items="OCTSFullData" title="OCTS Indicator Types">
        </bar-chart-card> -->
        <div style="display: flex; flex-wrap: nowrap; flex-direction: row">
            <div class="input">
                Type :
                <el-select v-model="form.resultChainType" placeholder="Type" class="select__field field input__field"
                    :disabled="resultChainDisabled" style="width: 208px">
                    <!-- .el-input.el-input--suffix {
    width: 208px;
} -->
                    <el-option v-for="item in resultChainTypes" :key="item.id" :label="item.type" :value="item.id">
                    </el-option>
                </el-select>
            </div>
            <div class="input">
                Result Chain :
                <el-select v-model="form.resultChain" placeholder="Result Chain" class="select__field field input__field"
                    :disabled="resultChainDisabled">
                    <el-option v-for="item in resultChainList" :key="item.id" :label="item.resultChain" :value="item.id">
                    </el-option>
                </el-select>
            </div>
            <div class="input">
                Indicator :
                <el-select v-model="form.indicator" placeholder="Indicator" class="select__field field input__field"
                    :disabled="resultChainDisabled">
                    <el-option v-for="item in indicatorList" :key="item.id"
                        :label="item.indicatorCode + ` - ` + item.indicator" :value="item.id">
                    </el-option>
                </el-select>
            </div>
            <div class="input">
                <base-button size="sm" type="primary" @click="getResultChainGraph()"
                    class="input__field addIndicatorBtn select__field" style="width: 150px !important; margin-top: 20px; height: 40px;"
                    v-if="form.indicator != ''">Show Graph<i class="el-icon-pie-chart"></i></base-button>
            </div>
            <div class="input">
                <!-- regionChartDisabled : {{ regionChartDisabled }}
                OctsChartDisabled : {{OctsChartDisabled}} -->
                <base-button size="sm" type="primary" @click="handleExport()"
                    class="input__field addIndicatorBtn select__field btn btn-primary chart__button"
                    v-if="!exportDisabled"><i class="el-icon-share"></i>Export</base-button>
            </div>
        </div>
        <div class="col-lg-12">
            <div v-if="isChartDisabled" class="chartDisabledText">
                Please select a Type, Result Chain and Indicator to show Graph
            </div>
            <div v-if="!isChartDisabled">
                <!-- <h1>Baseline Value</h1>
                <chart-card :items="chartDataBaseline" :title="indicatorName">
                </chart-card> -->
                <!-- {{ chartData }} -->
                <h1>OCTS wise Target and Final Value</h1>
                <!-- {{ OctsChartDisabled }} -->

                <BarChartCard2 :data="chartData" :title="indicatorName" type="octs" v-if="!OctsChartDisabled">
                </BarChartCard2>
                <h2 v-if="OctsChartDisabled">No Data</h2>
                <h1>Region wise Target and Final Value</h1>
                <!-- {{ regionChartDisabled }} -->

                <BarChartCard2 :data="chartData" :title="indicatorName" type="region" v-if="!regionChartDisabled">
                </BarChartCard2>
                <h2 v-if="regionChartDisabled">No Data</h2>
                <!-- <h1>Final Value</h1>

                <chart-card :items="chartDataFinal" :title="indicatorName">
                </chart-card> -->

                <!-- <bar-chart-card :items="chartDataFinal" :title="indicatorName">
                </bar-chart-card> -->

                <!-- <h1>Target Value</h1> -->

                <!-- <chart-card :items="chartDataTarget" :title="indicatorName">
                </chart-card> -->
            </div>
        </div>
        <!-- <multi-series-pie :chart-data="chartData2" :options="options" /> -->
    </div>
</template>
<style lang="scss" scoped>
.chart__button {
    width: 150px !important;
    margin-top: 20px;
    height: 40px;
}

h2 {
    color: #525f7f;
    text-align: center;
    padding: 30px;
    // border:1px dotted grey;
    background-color: white;
    border-radius: 20px;
}

.chartDisabledText {
    font-size: x-large;
    text-align: center;
}

.main {
    // margin-top: 40px;
}

.input {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 10px;
    margin-left: 5px;
    margin-top: 20px;
    margin-bottom: 10px;

    &__field {
        // max-width: 30vw;
    }
}

.select {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 10px;

    &__field {
        max-width: 30vw;
        border-color: 1px solid;
    }
}

h1 {
    margin-top: 60px;
    color: #525f7f;
}
</style>
<script>
// import ChartCard from "./../../pages/Dashboard/Cards/ChartCard";
// import ChartCard from "./Cards/ChartCard";
import ChartCard from "./../../pages/Dashboard/Cards/ChartCard";
import BarChartCard from "./../../pages/Dashboard/Cards/BarChartCard";
import BarChartCard2 from "./../../pages/Dashboard/Cards/BarChartCard2";
import MultiSeriesPie from "./../Charts/MultiSeriesPie";
import { LogMonitoringService } from "@/services";
import { Table, TableColumn, Select, Option, Pagination } from "element-ui";
import { Modal, BaseAlert, BasePagination } from "src/components";

export default {
    name: "BITool-Chart",
    components: {
        ChartCard,
        MultiSeriesPie,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        Modal,
        BaseAlert,
        BasePagination,
        [Select.name]: Select,
        [Option.name]: Option,
        Pagination,
        BarChartCard,
        BarChartCard2,
    },
    data() {
        return {
            resultChainList: [],
            indicatorList: [],
            resultChainTypes: [],
            form: {
                resultChainType: "",
                resultChain: "",
                indicator: "",
            },
            chartData: [],
            chartDataBaseline: [],
            chartDataFinal: [],
            chartDataTarget: [],
            OCTSFullData: [],
            isChartDisabled: true,
            resultChainDisabled: false,
            regionChartDisabled: true,
            exportDisabled: true,
            OctsChartDisabled: true,
            indicatorName: "",

            options: {
                responsive: true,
                maintainAspectRatio: false,
            },
        };
    },
    methods: {
        async handleExport() {
            var url = process.env.VUE_APP_ROOT_API + `/graph-export?result_chain_id=${this.form.resultChain}&indicator_id=${this.form.indicator}&type_id=${this.form.resultChainType}`;
            console.log(url);
            window.location = url;
            // await LogMonitoringService.exportGraph({
            //     resultChain_id: this.form.resultChain,
            //     indicator_id: this.form.indicator,
            //     type_id: this.form.resultChainType,
            // }).then((response) => {
            //     console.log(response);
            //     window.open(response.data.url);
            // });
        },
        async getResultChainTypes() {
            await LogMonitoringService.getResultChainTypes().then(
                (response) => {
                    this.resultChainTypes = response.data.data;
                }
            );
        },
        async getOCTSGraph() {
            await LogMonitoringService.getOCTSGraph().then((response) => {
                this.OCTSFullData = response.data.data.data;
            });
        },
        async getResultChainGraph() {
            this.indicatorName = "";
            this.OctsChartDisabled = false;
            this.regionChartDisabled = false;
            this.exportDisabled=false;
            // this.chartData=[];
            await LogMonitoringService.getResultChainGraph({
                resultChain_id: this.form.resultChain,
                indicator_id: this.form.indicator,
                type_id: this.form.resultChainType,
            }).then((response) => {
                // this.chartDataBaseline = response.data.data.data;
                this.chartData = response.data.data;
                this.chartDataBaseline = response.data.data.dataBaseline;
                this.chartDataFinal = response.data.data.dataFinal;
                this.chartDataTarget = response.data.data.dataTarget;
                this.indicatorName = response.data.data.indicator.indicator;
                this.isChartDisabled = false;
                if (
                    response.data.data.dataTarget.length == 0 &&
                    response.data.data.dataFinal.length == 0
                ) {
                    this.regionChartDisabled = true;
                    
                }
                if (
                    response.data.data.dataOctsTarget.length == 0 &&
                    response.data.data.dataOctsFinal.length == 0
                ) {
                    this.OctsChartDisabled = true;
                }
                if(this.regionChartDisabled == true&&this.OctsChartDisabled == true){
                    this.exportDisabled=true;
                }
            });
        },
    },
    mounted() {
        this.getResultChainTypes();
        this.getOCTSGraph();
    },
    watch: {
        "form.resultChainType": async function (val) {
            // if (!this.isUpdate) {
            this.form.resultChain = "";
            this.resultChainList = [];
            this.indicatorList = [];
            this.exportDisabled=true;
            // }
            // this.isChartDisabled = true;
            // this.chartData = [];
            await LogMonitoringService.getResultChain({
                type_id: this.form.resultChainType,
            }).then((response) => {
                this.resultChainList = response.data.data;
                console.log("Response of Result Chain", this.resultChainList);
                if (this.isUpdate && this.isCurrentlyEditing) {
                    this.form.resultChain = this.resultChain_forEdit;
                    this.isCurrentlyEditing = false;
                }
            });
        },
        "form.resultChain": async function (val) {
            // if (!this.isUpdate) {
            this.form.indicator = "";
            // }
            // this.isChartDisabled = true;
            // this.chartData = [];
            this.indicatorList = [];
            this.exportDisabled=true;

            await LogMonitoringService.getResultChainIndicators({
                resultChain_id: this.form.resultChain,
            }).then((response) => {
                this.indicatorList = response.data.data;
                console.log("Response of Result Chain", this.indicatorList);
                if (this.isUpdate && this.isCurrentlyEditing) {
                    this.form.resultChain = this.resultChain_forEdit;
                    this.isCurrentlyEditing = false;
                }
            });
        },
        "form.indicator": async function (val) {
            // this.OctsChartDisabled=true;
            // this.regionChartDisabled=true;
            this.exportDisabled=true;
        }
    },
};
</script>
